import { Maybe } from '@vimeo/core/types/generic';

import { EInteractionModule } from '../../types/interaction_tools';

/**
 * @returns whether if current interaction module is active in application
 */
export function checkModuleIsActive(
  activeModule: Maybe<EInteractionModule>,
  module: EInteractionModule,
): boolean {
  return (
    activeModule === undefined ||
    activeModule === EInteractionModule.AUTO ||
    activeModule === module
  );
}
